<div class="container postulacion-container mb-5">
    <div class="row mt-2 info-postulacion-container justify-content-center">
        <div class="col-12 col-md-8 col-lg-12">
            <div class="container">
                <div class="card w-100 mx-auto shadow-lg">
                    <div class="card-body p-5">
                        <div class="card-title mb-4 text-center">
                            <h4 class="fw-bold mb-2">¡Bienvenido(a)!</h4>
                            <p class="text-muted mb-4">Elige la opción que mejor se adapte a ti</p>
                        </div>

                        <div class="row g-4 mt-2">
                            <!-- Opción 1: Registro Rápido -->
                            <div class="col-12 col-md-6">
                                <div class="card h-100 option-card border-0 shadow-sm hover-card" (click)="irARegistroRapido()">
                                    <div class="card-body text-center p-4">
                                        <div class="mb-3">
                                            <i class="bi bi-lightning-charge-fill text-primary" style="font-size: 3rem;"></i>
                                        </div>
                                        <h5 class="fw-bold mb-3">Registro con Formulario</h5>
                                        <p class="text-muted mb-3">Completa tu registro con información básica</p>
                                        <ul class="list-unstyled text-start mb-3">
                                            <li class="mb-2">
                                                <i class="bi bi-check-circle-fill text-success me-2"></i>
                                                <small>Datos personales básicos</small>
                                            </li>
                                            <li class="mb-2">
                                                <i class="bi bi-check-circle-fill text-success me-2"></i>
                                                <small>Información de contacto</small>
                                            </li>
                                            <li class="mb-2">
                                                <i class="bi bi-check-circle-fill text-success me-2"></i>
                                                <small>Experiencia laboral</small>
                                            </li>
                                        </ul>
                                        <button type="button" class="btn btn-primary w-100 mt-auto" (click)="$event.stopPropagation()">
                                            Comenzar Registro Corto
                                            <i class="bi bi-arrow-right ms-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Opción 2: Registro con CV -->
                            <div class="col-12 col-md-6">
                                <div class="card h-100 option-card border-0 shadow-sm hover-card" (click)="irARegistroCV()">
                                    <div class="card-body text-center p-4">
                                        <div class="mb-3">
                                            <i class="bi bi-file-earmark-person-fill text-info" style="font-size: 3rem;"></i>
                                        </div>
                                        <h5 class="fw-bold mb-3">Registro Subiendo tu CV</h5>
                                        <p class="text-muted mb-3">Sube tu CV y nosotros extraemos tu información automáticamente</p>
                                        <ul class="list-unstyled text-start mb-3">
                                            <li class="mb-2">
                                                <i class="bi bi-check-circle-fill text-success me-2"></i>
                                                <small>Carga tu CV</small>
                                            </li>
                                            <li class="mb-2">
                                                <i class="bi bi-check-circle-fill text-success me-2"></i>
                                                <small>Extracción automática de datos</small>
                                            </li>
                                            <li class="mb-2">
                                                <i class="bi bi-check-circle-fill text-success me-2"></i>
                                                <small>Revisa y completa tu información</small>
                                            </li>
                                        </ul>
                                        <button type="button" class="btn btn-info w-100 mt-auto" (click)="$event.stopPropagation()">
                                            Comenzar con CV
                                            <i class="bi bi-arrow-right ms-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="text-center mt-4">
                            <p class="text-muted mb-0">
                                ¿Ya tienes una cuenta? 
                                <a routerLink="/login" class="text-primary text-decoration-none fw-semibold">Inicia sesión aquí</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
